/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetUploadIcon20Regular = forwardRef('NetUploadIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4.873 7.06a.75.75 0 1 1-.996-1.12l4.379-3.893a2.625 2.625 0 0 1 3.488 0l4.38 3.892a.75.75 0 0 1-.997 1.122L10.75 3.17v10.08a.75.75 0 0 1-1.5 0V3.17L4.873 7.06Z" }),
        React.createElement("path", { d: "M2.25 17a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z" })));
});
